var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._v("Make your Setlist!")]),_c('v-spacer')],1),_c('setlist')],1)}
var staticRenderFns = []

export { render, staticRenderFns }